import LikesAPI from '../api/LikesApi';

class LikesRepository {
  private likesAPI = new LikesAPI();

  public getEntityLikes(entityId: string) {
    return this.likesAPI.getEntityLikes(entityId);
  }
}

export default LikesRepository;
